

// 0‑6  (Sun … Sat)
const NAME_TO_NUM = {
  Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3,
  Thursday: 4, Friday: 5, Saturday: 6,
};

// get 1‑5 occurrence index of that weekday in its month
const nthOfMonth = (m) => Math.floor((m.date() - 1) / 7) + 1;

/**
 * Turn ONE textual rule -> predicate(dateMoment) => true/false
 */
export function ruleToMatcher(rule) {
  rule = rule.trim();

  // ------------- “Everyday”
  if (/^every\s*day$/i.test(rule) || /^everyday$/i.test(rule))
    return () => true;

  // ------------- “Weekday”  /  “Monday to Friday”
  if (/weekday/i.test(rule) || /monday\s*to\s*friday/i.test(rule))
    return (d) => d.day() >= 1 && d.day() <= 5;

  // ------------- Simple weekday
  if (NAME_TO_NUM[rule])
    return (d) => d.day() === NAME_TO_NUM[rule];

  // ------------- “Last Friday”
  const lastMatch = /^last\s+(\w+day)$/i.exec(rule);
  if (lastMatch) {
    const wd = NAME_TO_NUM[lastMatch[1]];
    return (d) =>
      d.day() === wd &&
      d.clone().add(7, "days").month() !== d.month(); // next week spills month
  }

  // ------------- “Alternate Tuesday”
  const altMatch = /^alternate\s+(\w+day)$/i.exec(rule);
  if (altMatch) {
    const wd = NAME_TO_NUM[altMatch[1]];
    return (d) =>
      d.day() === wd && nthOfMonth(d) % 2 === 1; // 1st,3rd,5th weeks
  }

  // ------------- “4th or 5th Saturday of the Month”
  const ordMatch = /^(\d(st|nd|rd|th))(?:\s+or\s+(\d(st|nd|rd|th)))?\s+(\w+day)/i.exec(
    rule
  );
  if (ordMatch) {
    const wantedOrdinals = [ordMatch[1], ordMatch[3]].filter(Boolean).map((o) => parseInt(o));
    const wd = NAME_TO_NUM[ordMatch[5]];
    return (d) => d.day() === wd && wantedOrdinals.includes(nthOfMonth(d));
  }

  // ------------- “By Appointment”  →  allow nothing automatically
  return () => true;
}
